import API from "../Services/API";
import Model from "./Model";

const useSavedSearches = (category, alwaysRefresh = false) => {
    return Model({
        stateKey: ['searches', category],
        alwaysRefresh: alwaysRefresh,
        fetchData: () => API.get(`/searches/${category}`),
        returnDataKey: 'searches',
        defaultLoadingError: 'Sorry, there was an error loading saved searches.',
        registerAdditionalMethods: (opts) => ({
            saveSearch: (search) => {
                return opts.wrapUpdateCall(
                    () => API.post(`/searches`, search),
                    'Search saved',
                    true,
                );
            },
            deleteSearch: (searchId) => {
                return opts.wrapUpdateCall(
                    () => API.delete(`/searches/${searchId}`),
                    'Search deleted',
                    true,
                );
            }
        }),
    })
}

const useSuggestName = (category, search, ready) => {
    const searchJson = JSON.stringify(search);
    const data = Model({
        block: !(search || searchJson !== '{}') && ready,
        stateKey: ['suggestions', category, searchJson],
        fetchData: () => API.post(`/searches/name`, {category, search}),
        returnDataKey: 'suggestion',
    });

    return data?.suggestion?.suggestion ?? null;
}

export {
    useSavedSearches,
    useSuggestName,
};
